import { useEffect, useState } from 'react';
import * as R from 'ramda';
import axios from 'axios';
import { downloadZip } from 'client-zip';
import { getFileName } from '../Services/ValueTransform';

const ExportModal = ({ show, selecteds, handleClose }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (show === true && selecteds.length > 0) {
      startJob();
    }
  }, [show]);

  const startJob = async () => {
    const toExportFans = [...selecteds];
    const zipBuffer = [];
    for (let i = 0; i < toExportFans.length; i++) {
      const { data } = await doExport(toExportFans[i]);
      if (data) {
        const name = getFileName(toExportFans[i]);
        zipBuffer.push({
          name: `${name}.pdf`,
          lastModified: new Date(),
          input: data,
        });
      }
      setProgress(i + 1);
    }
    const zipBlob = await downloadZip(zipBuffer).blob();
    const link = document.createElement('a');
    const downloadUrl = URL.createObjectURL(zipBlob);
    link.href = downloadUrl;
    link.download = 'DyuniAir_Export.zip';
    link.click();
    link.remove();
    URL.revokeObjectURL(downloadUrl);
  };

  const doExport = async (fan) => {
    return await axios.get(`/api/v1/generate-pdf/${fan.id}`, {
      responseType: 'blob',
      params: fan.configs,
    });
  };

  const getProgress = () => {
    if (!selecteds || selecteds.length <= 0) return 0;
    return (progress / selecteds.length) * 100;
  };

  const onClose = (e) => {
    handleClose(e);
    setProgress(0);
  };

  if (!show) return null;
  return (
    <div
      class='relative z-10'
      aria-labelledby='modal-title'
      role='dialog'
      aria-modal='true'
    >
      <div
        class='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity'
        style={{ backgroundColor: '#6f6f6fbf' }}
      ></div>

      <div
        class='fixed inset-0 z-10 w-screen overflow-y-auto'
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <div
          class='flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0'
          style={{ height: '290px', marginTop: '130px' }}
        >
          <div class='relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg'>
            <div class='bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4'>
              <div class='sm:flex sm:items-start'>
                <div class='mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left'>
                  <h2
                    class='text-base font-semibold leading-5 text-gray-900 mt-6'
                    id='modal-title'
                  >
                    Export PDF
                  </h2>
                  <div class='mt-6'>
                    <div class='prwrapper'>
                      <div class='progress-bar'>
                        <span
                          class='progress-bar-fill'
                          style={{ width: getProgress() + '%' }}
                        ></span>
                      </div>
                      <div>
                        {selecteds.length > 0 && selecteds.length != progress
                          ? `Processing ${progress}/${selecteds.length}`
                          : `Complete ${selecteds.length}/${selecteds.length}`}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class='bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6'
              style={{ justifyContent: 'flex-end', columnGap: 50 }}
            >
              {progress === selecteds.length && (
                <button type='button' class='btn-custom py-2' onClick={onClose}>
                  Close
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExportModal;
